<template>
  <div>
    <CreateTaskForm
      :user="user"
      :date="date"
      :initSubject="initSubject"
      :theNewlyCreatedSubject="theNewlyCreatedSubject"
      :editEvent="editEvent"
      :openingHours="openingHours"
      @setDate="setDate"
      @close="$emit('close')"
      @createNewSubject="setCreateNewSubject($event)"
      @onCreatedEvent="onCreatedEvent"
      @deleteEvent="onDeleteEvent"
      @updatedEvent="$emit('updatedEvent', $event)">
    </CreateTaskForm>
    <CreateTaskNewSubject
      v-if="theCreateNewSubjectName"
      :user="user"
      :date="date"
      :title="theCreateNewSubjectName"
      @newSubject="onNewSubject"
      @close="setCreateNewSubject(null)">
    </CreateTaskNewSubject>
    <ModalConfirmation v-if="theDeleteEvent"
                       :isSubmitButtonLoading="isDeleting"
                       @confirm="deleteEvent"
                       @close="onCloseConfirmation">
    </ModalConfirmation>
  </div>
</template>
<script>
import CreateTaskForm from './CreateEventForm.vue'
import CreateTaskNewSubject from './CreateEventNewSubject.vue'
import moment from 'moment'
import ModalConfirmation from '../../Modals/ModalConfirmation.vue'
import docendo from '../../../docendo'

export default {
  components: {ModalConfirmation, CreateTaskNewSubject, CreateTaskForm},
  props: {
    user: {
      type: Object,
      default: null
    },
    initDate: {
      type: Object,
      default: () => moment()
    },
    initSubject: {
      type: Object,
      default: null
    },
    emitEvent: {
      type: Boolean,
      default: false
    },
    editEvent: {
      type: Object,
      default: null
    },
    openingHours: {
      default: null
    }
  },
  data () {
    return {
      date: moment(),
      theCreateNewSubjectName: null,
      theNewlyCreatedSubject: null,
      theDeleteEvent: null,
      isDeleting: false
    }
  },
  methods: {
    deleteEvent () {
      this.isDeleting = true
      const schoolId = this.theDeleteEvent.school_id
      const eventId = this.theDeleteEvent.event_id
      docendo.deleteEvent(schoolId, eventId, success => {
        this.onCloseConfirmation()
        this.$emit('deletedEvent', success)
      }, failure => {
        console.log({failure})
      })
    },
    onCloseConfirmation () {
      this.onDeleteEvent(null)
    },
    onDeleteEvent (lesson) {
      this.theDeleteEvent = lesson
    },
    onCreatedEvent (lesson) {
      // Antag at this.initDate er i ISO 8601 format
      const initDate = this.initDate

      // Start og slutdato fra eventet
      const eventStart = lesson.start
      const eventEnd = lesson.end

      // Brug moment.js til at konvertere datoerne til moment objekter
      const initDateMoment = moment(initDate)
      const eventStartMoment = moment(eventStart)
      const eventEndMoment = moment(eventEnd)

      // Tjek om både start og slutdatoer matcher initDate
      const isStartDateSame = eventStartMoment.isSame(initDateMoment, 'day')
      const isEndDateSame = eventEndMoment.isSame(initDateMoment, 'day')
      if (this.emitEvent) {
        this.$emit('addANewEvent', lesson)
        return
      }
      if (isStartDateSame && isEndDateSame) {
        this.$store.commit('addANewEvent', lesson)
      }
    },
    setDate (mom) {
      this.date = mom
    },
    setCreateNewSubject (str) {
      this.theCreateNewSubjectName = str
    },
    onNewSubject (subject) {
      this.theNewlyCreatedSubject = subject
      this.setCreateNewSubject(null)
    }
  },
  beforeMount () {
    if (this.editEvent) {
      this.date = moment(this.editEvent.start)
      return
    }
    this.date = this.initDate
  }
}
</script>



// WEBPACK FOOTER //
// CreateEvent.vue?d54e63da